import { useTranslation } from 'react-i18next';

const checks = [
  'checklist1', 'checklist2', 'checklist3', 'checklist4', 'checklist5',
];

export default function SafetySection() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-20 bg-warm-50">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-warm-900 mb-3">
              {t('safety.h2')}
            </h2>
            <h3 className="text-lg font-semibold text-warm-700 mb-4">
              {t('safety.h3')}
            </h3>
            <p className="text-sm md:text-base text-warm-500 leading-relaxed mb-6">
              {t('safety.description')}
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-brand-600 text-white text-sm font-medium rounded-full hover:bg-brand-700 transition-colors"
            >
              {t('hero.ctaPrimary')}
              <i className="ri-arrow-right-line" />
            </a>
          </div>

          <div className="bg-white rounded-xl border border-warm-200 p-5 md:p-6">
            <h4 className="text-sm font-semibold text-warm-800 uppercase tracking-wide mb-4">
              Safety Checklist
            </h4>
            <ul className="space-y-3">
              {checks.map((check) => (
                <li key={check} className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-emerald-50 border border-emerald-200 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-emerald-600 text-xs" />
                  </div>
                  <span className="text-sm text-warm-600">
                    {t(`safety.${check}`)}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}